<template>
    <div>
        <Tab />
        <router-view></router-view>
    </div>
</template>
<script>
import Tab from "./Tab";
import initAnimation from "../animation"
export default {
    mounted(){
        setTimeout(initAnimation,0);
    },
    components: {
        Tab,
    },
};
</script>



// WEBPACK FOOTER //
// src/Pages/Hardware/Hardware.vue